import axios from 'axios';
import { ChatModel } from '../Chat.Interfaces';

export const getChatData = (): Promise<ChatModel> => {
	return axios.get('/livechat/getchatdata/').then(response => {
		return response.data as ChatModel;
	});
};
